import React, { useContext, useEffect, useState } from "react";
import { withRouter, NavLink, useHistory } from "react-router-dom";
import AuthContext from "../../context/auth/AuthContext";
import AlertContext from "../../context/alert/AlertContext";
import ConfigContext from "../../context/config/ConfigContext";
import CardContext from "../../context/card/CardContext";
import CartContext from "../../context/cart/CartContext";
import GroupContext from "../../context/group/GroupContext";
import SubscribeContext from "../../context/subscribe/SubscribeContext";
import EmployeeContext from "../../context/employee/EmployeeContext";
import CompCardContext from "../../context/comp-card/CompCardContext";
import { Fragment } from "react";

const ActionMenu = ({ resetUseIdleTimer }) => {
  const authContext = useContext(AuthContext);
  const { user, logout, token } = authContext;
  const alertContext = useContext(AlertContext);
  const configContext = useContext(ConfigContext);
  const cardContext = useContext(CardContext);
  const cartContext = useContext(CartContext);
  const groupContext = useContext(GroupContext);
  const subscribeContext = useContext(SubscribeContext);
  const employeeContext = useContext(EmployeeContext);
  const compCardContext = useContext(CompCardContext);

  const { resetCardState } = cardContext;
  const { resetCartState } = cartContext;
  const { resetSubscribeState } = subscribeContext;
  const { resetGroupState } = groupContext;
  const { resetEmployeeState } = employeeContext;
  const { resetCompCardState } = compCardContext;
  const { resetConfigState, getConfigValueByCode } = configContext;
  const { setAlert, clearAlerts } = alertContext;
  const { cart } = cartContext;

  const history = useHistory();

  const onLogout = async () => {
    console.log("Logging out....");
    resetUseIdleTimer();
    clearAlerts();
    resetCardState();
    resetCartState();
    resetSubscribeState();
    resetGroupState();
    resetEmployeeState();
    resetCompCardState();
    resetConfigState();
    try {
      await logout(token);
    } catch (err) {
      const msg = getConfigValueByCode("patronConfig", "RESPONSE_MSG", 465);
      setAlert(msg, "danger");
      history.push("/");
    }
  };

  const [toggleMenu, setToggleMenu] = useState(false);

  const menuToggle = () => {
    setToggleMenu(!toggleMenu);
  };

  // const [windowWidth, setWindowWidth] = useState(getWindowWidth());

  // function getWindowWidth() {
  //   const { innerWidth: width } = window;
  //   return width;
  // }

  // useEffect(() => {
  //   window.addEventListener("resize", setWindowWidth(getWindowWidth()));
  //   return () =>
  //     window.removeEventListener("resize", setWindowWidth(getWindowWidth()));
  // });

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  const screenSizeChanged = () => {
    setWindowWidth(window.innerWidth);
  };

  useEffect(() => {
    window.addEventListener("resize", screenSizeChanged);
    return () => window.removeEventListener("resize", screenSizeChanged);
  });

  console.log("windowWidth", windowWidth);

  return (
    <aside id="action-menu" className="action-menu-card">
      <h2 className="title action-menu-card__title">
        {user && user.firstName + " " + user.lastName}
        {windowWidth <= 800 && (
          <button className="action-menu-card__menu" onClick={menuToggle}>
            {toggleMenu ? (
              <i className="fas fa-times" aria-label="Close"></i>
            ) : (
              <i className="fas fa-bars"></i>
            )}
          </button>
        )}
      </h2>
      <ul
        className={
          toggleMenu
            ? "action-menu-card__list__active"
            : "action-menu-card__list"
        }
      >
        {user && user.sponsor ? (
          <Fragment>
            <li>
              <NavLink
                to="/company_mgmt"
                activeClassName="action-menu-card__list__checked"
                onClick={() => clearAlerts()}
              >
                <i className="fas fa-tags"></i> Company Card Management
              </NavLink>
            </li>
            <li>
              <NavLink
                activeClassName="action-menu-card__list__checked"
                to="/emp_mgmt"
                onClick={() => clearAlerts()}
              >
                <i className="far fa-address-card"></i> Employee Management
              </NavLink>
            </li>
            <li>
              <NavLink
                activeClassName="action-menu-card__list__checked"
                to="/group_mgmt"
                onClick={() => clearAlerts()}
              >
                <i className="fa fa-users"></i> Group Management
              </NavLink>
            </li>
          </Fragment>
        ) : (
          <Fragment>
            <li>
              <NavLink
                activeClassName="action-menu-card__list__checked"
                to="/cards"
                onClick={() => clearAlerts()}
              >
                <i className="fas fa-tags"></i> My Cards
              </NavLink>
            </li>
          </Fragment>
        )}
        <li>
          <NavLink
            activeClassName="action-menu-card__list__checked"
            to="/recharge/default"
            onClick={() => clearAlerts()}
          >
            <i className="fas fa-money-check"></i> Reload Q Card
          </NavLink>
        </li>
        <li>
          <NavLink
            activeClassName="action-menu-card__list__checked"
            to="/subscribe/default"
            onClick={() => clearAlerts()}
          >
            <i className="fas fa-money-check-alt"></i> Subscription
          </NavLink>
        </li>
        <li>
          <NavLink
            activeClassName="action-menu-card__list__checked"
            to="/user-cart"
            onClick={() => clearAlerts()}
          >
            <i className="fas fa-shopping-cart"></i> Cart{" "}
            {cart
              ? cart.cartItems.length > 0 && (
                  <span className="action-menu-card_cart-length">
                    ({cart.cartItems.length})
                  </span>
                )
              : ""}
          </NavLink>
        </li>
        <li>
          <NavLink
            activeClassName="action-menu-card__list__checked"
            to="/order"
            onClick={() => clearAlerts()}
          >
            <i className="fas fa-receipt"></i> &nbsp;Order History
          </NavLink>
        </li>
        <li>
          <NavLink
            activeClassName="action-menu-card__list__checked"
            to="/account"
            onClick={() => clearAlerts()}
          >
            <i className="fa fa-cog"></i> Account Settings
          </NavLink>
        </li>
      </ul>
      <input
        className={
          toggleMenu
            ? "action-menu-card__button__active"
            : "action-menu-card__button"
        }
        onClick={onLogout}
        type="button"
        value="Logout"
      ></input>
    </aside>
  );
};

export default withRouter(ActionMenu);
